import styled from 'styled-components';

export const InputFieldWrapper = styled.div`
  display: flex;
  margin-bottom: 18px;
`;

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  label {
    margin-bottom: 5px !important;
  }
`;

export const SliderInput = styled.input`
  appearance: none;
  width: 100%;
  height: 24px;
  background: ${({ theme }) => theme.colors.minimumGreenIcon};
  border: 1px solid ${({ theme }) => theme.colors.white};
  border-radius: 60px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    box-shadow: 0 2px 5px ${({ theme }) => theme.colors.black_4};
  }

  &::-moz-range-thumb {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    box-shadow: 0 2px 5px ${({ theme }) => theme.colors.black_4};
  }
`;

export const SliderLabel = styled.label`
  display: flex;
  color: ${({ theme }) => theme.colors.standardTextGrey};
  font-weight: normal;
`;
